import { useRecoilState } from "recoil";
import { profilePrefillMetadataState } from "../SimpleForm/Atoms/Profiles/state";

/**
 * @description Used to provide recoil state to child component. Feel free to add state as needed.
 */
const RecoilStateProvider = ({ children }) => {
  const [profilePrefillMetadata, setProfilePrefillMetadata] = useRecoilState(
    profilePrefillMetadataState
  );

  return children({ profilePrefillMetadata, setProfilePrefillMetadata });
};

export default RecoilStateProvider;
